import React from 'react';
import CatalogDisplayItem from '@/widgets/CatalogDisplayItem/CatalogDisplayItem';
import { ECatalogDisplayItemType, ECatalogDisplayViewType } from 'tkmp-lib/src/enums';
import { Layout } from 'antd';
import cd from './CatalogDisplay.module.scss';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/utils/hooks/useStores';

const CatalogDisplay = observer(({ items, cid, favourites, compares, basketList }: any) => {
    const {
        systemStore: { CATALOG_DISPLAY_TYPE },
    } = useStores();
    // console.log('items',items)
    return (
        <Layout
            className={
                CATALOG_DISPLAY_TYPE === ECatalogDisplayViewType.Grid
                    ? cd.gridContainer
                    : cd.listContainer
            }
        >
            {items?.resultSet?.map((item: any) => (
                <CatalogDisplayItem
                    key={item.slug}
                    element={item}
                    type={ECatalogDisplayItemType.Catalog}
                    cid={cid}
                    isFavouriteInitial={favourites?.items?.some(
                        (favItem: any) => favItem?.slug === item?.slug,
                    )}
                    isCompareInitial={compares?.some(
                        (comItem: any) => comItem?.productSlug === item?.slug,
                    )}
                />
            ))}
        </Layout>
    );
});

export default CatalogDisplay;
